import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "primeng/api";
import { RippleModule } from "primeng/ripple";
import { VComponentsModule } from "../modules/wrappers";
import { VSidebarComponent } from "./v-sidebar.component";
import { GcAbsenceSidebarComponent } from "./components/absence/absence.sidebar.component";
import { DuplicateSidebarComponent } from "./components/duplicates/duplicate.sidebar.component";
import { HelpSidebarComponent } from "./components/help/help.sidebar.component";
import { LawSidebarComponent } from "./components/law/law.sidebar.component";
import { PersonShortcutSidebarComponent } from "./components/person-shortcut/person-shortcut.sidebar.component";
import { ProjectDuplicateSidebarComponent } from "./components/project-duplicate/project-duplicate.sidebar.component";
import { ContractAdjustmentInfoSidebarComponent } from "./components/contractAdjustmentInfo/contractAdjustmentInfo.sidebar.component";
import { GcReactiveForms } from "../modules/ngx-components";
import { DrawerModule } from "primeng/drawer";
import { ComponentsModule } from "../components/components.module";
import { ChipModule } from "primeng/chip";
import { FontAwesomeModule, GcLayoutModule, VTranslateDirective } from "../util/defaultModules";
import { DialogModule } from "primeng/dialog";
import { AccordionModule } from "primeng/accordion";
import { TableModule } from "primeng/table";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        RippleModule,
        FormsModule,
        ReactiveFormsModule,
        VComponentsModule,
        GcReactiveForms,
        DrawerModule,
        ComponentsModule,
        ChipModule,
        GcLayoutModule,
        DialogModule,
        AccordionModule,
        TableModule,
        FontAwesomeModule,
        VTranslateDirective,
    ],
    exports: [
        VSidebarComponent,
        GcAbsenceSidebarComponent,
        ContractAdjustmentInfoSidebarComponent,
        DuplicateSidebarComponent,
        HelpSidebarComponent,
        LawSidebarComponent,
        PersonShortcutSidebarComponent,
        ProjectDuplicateSidebarComponent,
    ],
    declarations: [
        VSidebarComponent,
        GcAbsenceSidebarComponent,
        ContractAdjustmentInfoSidebarComponent,
        DuplicateSidebarComponent,
        HelpSidebarComponent,
        LawSidebarComponent,
        PersonShortcutSidebarComponent,
        ProjectDuplicateSidebarComponent,
    ]
})
export class VSidebarModule{}
